import React from "react";
import { dialog, Button } from "nq-component";
import Table from "../../../components/Table";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../usecases/object";
import { InfiniteScroll } from "nq-component";
import withRouter from "../../../withRouter";
import Search from "../../../components/Search";
import BaseListPage from "../../../base/BaseListPage";
import CardView from "../../../components/common/CardView";
import LibraryPresenter from "./LibraryPresenter";
import LibraryForm from "./library-form/LibraryForm";
import LibraryFormView from "./library-form/LibraryFormView";
import Progress from "../../../components/Progress";

class LibraryPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new LibraryPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase()
    );
    this.state = {
      isModalOpen: false,
      objects: [],
      object: {},
      viewObject: {},
      viewModal: false,
      count: 0,
      limit: 10,
      current: 1,
    };
  }

  getCollectionName() {
    return "library";
  }
  // delete function
  async handleDeleteData(data) {
    await this.presenter.deleteObjectUseCase.execute("library", data.id);
    this.refetchData();
  }

  // edit function
  async handleEditData(id) {
    const library = await findObjectUseCase().execute("library", {
      where: { id: id },
    });
    this.setState({ object: library[0], isModalOpen: true });
  }

  async handleViewObject(object) {
    const library = await findObjectUseCase().execute("library", {
      where: { id: object.id },
    });
    this.setState({ viewModal: true, viewObject: library[0] });
  }

  handleCloseView() {
    this.setState({ viewModal: false });
  }

  async refetchData() {
    const objects = await this.presenter.getObjects();
    this.filterSubmit({});
    return objects;
  }

  handleCollectionForm() {
    this.setState({ isModalOpen: true });
  }

  closeForm() {
    this.setState({ isModalOpen: false, object: {} });
  }

  onClickPagination(page) {
    this.presenter.setCurrentPage(page);
  }

  setObjects(objects) {
    this.setState({ objects });
  }

  setCurrent(current) {
    this.setState({ current });
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const { objects, loading, count, current, limit } = this.state;
    if (!schema) return <Progress />;
    // const user = this.getCurrentUser();
    return (
      <>
        <div className="overflow-auto" style={{ marginTop: "5rem" }}>
          <InfiniteScroll
            className="h-100"
            loadMore={this.loadMore.bind(this)}
            // hasMore={!progress && count > objects.length}
          >
            <div className="p-3 p-lg-4">
              <div
                className="d-flex mb-4"
                style={{ borderBottom: "1.5px solid #d3d3d3" }}
              >
                <p style={{ fontSize: ".9rem", color: "rgba(0, 0, 0, .45)" }}>
                  You are here: Home {">"} Human Resource {">"}{" "}
                  <span
                    style={{ fontSize: "1rem", color: "rgba(0, 0, 0, .70)" }}
                  >
                    {schema.collection}
                  </span>
                </p>
              </div>
              <CardView style={{ borderRadius: 0 }}>
                <Search
                  schemas={this.getSchemas()}
                  onSubmit={this.searchSubmit.bind(this)}
                  fields={schema.fields}
                />
              </CardView>

              <div
                style={{
                  marginTop: "20px",
                  width: "100%",
                }}
              >
                <CardView style={{ borderRadius: 0 }}>
                  <div className="d-flex align-items-center justify-content-center">
                    <h4 className="text-primary">{schema.label}</h4>
                    <div style={{ marginLeft: "auto" }}>
                      <Button
                        onClick={this.handleCollectionForm.bind(this)}
                        // onClick={this.onClickAdd.bind(this)}
                      >
                        <i className="bi bi-plus-lg" /> New {schema.collection}
                      </Button>
                    </div>
                  </div>
                </CardView>
              </div>

              <Table
                objectId={this.handleDeleteData.bind(this)}
                editId={this.handleEditData.bind(this)}
                viewObject={this.handleViewObject.bind(this)}
                progress={loading}
                refetch={this.refetchData.bind(this)}
                fields={schema.fields}
                objects={objects}
                collection={schema}
                count={count}
                limit={limit}
                current={current}
                loadPagination={this.onClickPagination.bind(this)}
                actionsList={[
                  {
                    label: <i className="bi bi-three-dots-vertical" />,
                    actionType: "common",
                  },
                ]}
                // selectable
                // collapsable
                excludeFields={Object.keys(schema.fields).reduce(
                  (acc, key) => {
                    const options = schema.fields[key];
                    if (options.read === false) {
                      acc.push(key);
                    }
                    switch (options._type || options.type) {
                      case "Relation":
                      case "Array":
                      case "Object":
                      case "File":
                        acc.push(key);
                        break;
                      default:
                    }
                    return acc;
                  },
                  ["Id", "Created At", "Updated At", "user"]
                )}
                // selected={selected}
                // onSelect={this.onSelect.bind(this)}
                // onSelectAll={this.onSelectAll.bind(this)}
                // progress={progress}
                onClickItem={this.onClickItem.bind(this)}
              />
            </div>
          </InfiniteScroll>
        </div>
        {this.state.isModalOpen && (
          <LibraryForm
            closeCollection={this.closeForm.bind(this)}
            refetchData={this.refetchData.bind(this)}
            object={this.state.object}
          />
        )}

        {this.state.viewModal && (
          <LibraryFormView
            closeCollection={this.handleCloseView.bind(this)}
            object={this.state.viewObject}
          />
        )}
      </>
    );
  }
}

export default withRouter(LibraryPage);
